import { AwardType } from '@/types/awards';

export const AWARDS_VIDEOS: Record<AwardType, string[]> = {
	[AwardType.Orpetron]: [
		'/assets/video/mov/award-orpetron.mov',
		'/assets/video/webm/award-orpetron.webm'
	],
	[AwardType.CSSDesignAwards]: [
		'/assets/video/mov/award-cssda.mov',
		'/assets/video/webm/award-cssda.webm'
	],
	[AwardType.ClutchAwards]: [
		'/assets/video/mov/award-clutch.mov',
		'/assets/video/webm/award-clutch.webm'
	],
	[AwardType.FWA]: ['/assets/video/mov/award-fwa.mov', '/assets/video/webm/award-fwa.webm'],
	[AwardType.WorldBrandDesignAwards]: [
		'/assets/video/mov/award-wbd.mov',
		'/assets/video/webm/award-wbd.webm'
	],
	[AwardType.Awwwards]: ['/assets/video/mov/award-www.mov', '/assets/video/webm/award-www.webm']
};

export const AWARDS_IMAGES: Record<AwardType, string> = {
	[AwardType.Orpetron]: '/assets/images/case-study/awards/orpetron.webp',
	[AwardType.Awwwards]: '/assets/images/case-study/awards/awwwards.webp',
	[AwardType.CSSDesignAwards]: '/assets/images/case-study/awards/css.webp',
	[AwardType.FWA]: '/assets/images/case-study/awards/fwa.webp',
	[AwardType.WorldBrandDesignAwards]: '/assets/images/case-study/awards/wbda.webp',
	[AwardType.ClutchAwards]: ''
};
